import { createApp, type App } from 'vue';
import PasswordChangeModal from './password-change-modal.vue';
import AntDesignVue from 'ant-design-vue';

const MOUNT_ID = 'password-change-modal-vue';

let passwordChangeModalApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

function findMountElement(root?: ParentNode): HTMLElement | null {
  if (root) {
    return root.querySelector<HTMLElement>(`#${MOUNT_ID}`);
  }
  return document.getElementById(MOUNT_ID);
}

export function initPasswordChangeModal(root?: ParentNode): void {
  const mountEl = findMountElement(root);
  if (!mountEl) return;

  destroyPasswordChangeModal();

  mountEl.innerHTML = '';
  const settingsRoot =
    mountEl.closest('.resident-lk-settings') ??
    mountEl.closest('.personal-area__settings') ??
    mountEl.closest('[data-barba="container"]') ??
    document;
  const app = createApp(PasswordChangeModal);
  passwordChangeModalApp = app;
  app.provide('passwordSettingsRoot', settingsRoot);
  app.use(AntDesignVue).mount(mountEl);
  currentMountEl = mountEl;
}

export function destroyPasswordChangeModal(): void {
  if (!passwordChangeModalApp || !currentMountEl) return;

  passwordChangeModalApp.unmount();
  currentMountEl.innerHTML = '';
  passwordChangeModalApp = null;
  currentMountEl = null;
}